import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {BusinessService} from '../../../common/services/Business.service';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute} from '@angular/router';
import {Store} from '@ngrx/store';
import * as auth from '../../../common/actions/authentication';
import * as fromRoot from '../../../common/reducers';

declare var $: any;
declare var AccountKit: any;


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'reset-password-login',
  templateUrl: './reset-password-login.component.html',
  providers: [BusinessService]
})
export class ResetPasswordLoginComponent implements OnInit {
  public phone: string;
  public code: string;
  public password: string;
  public cpassword: string;
  public error: string;
  public model: any = {};
  public message: { class: string, content: string } = null;
  public codeOTP: string;
  public validate_password: boolean = false;
  check: boolean;
  public prePassword: string;
  public preUsername: string;
  public ttl_in_second: any;

  constructor(
    private toastr: ToastrService,
    public businessService: BusinessService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private store: Store<fromRoot.State>,
  ) {
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      const username = params['username'];
      const password = params['password'];
      const ttl_in_second = params['ttl_in_second'];
      this.prePassword = password;
      this.preUsername = username;
      this.ttl_in_second = ttl_in_second
    });
  }
  onSubmit(data) {
    const obj = {
      password: this.prePassword,
      new_password: data.password,
      confirm_password: data.confirm_password,
    };
    this.businessService.changePasswordLoginFirst(obj).subscribe(res => {
      console.log('res', res)
      if (res.status == 200) {
        const mUser = {
          username: this.preUsername,
          password: data.password,
          ttl_in_second: 86400 * 3,
        };
        this.store.dispatch(new auth.LoginAction(mUser));
      }
    }, (error) => {
      console.log('erroosd', error)
    })
  }
  backToLogin() {
    this.router.navigate(['/login'])
  }


}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/auth/reset-password-login.component.ts